import { useContext } from "react";
import React from "react";
import { Dropdown, Input, Table, Label, Form } from "semantic-ui-react";
import { Action, store } from "../store";
import { dateValidator, QAPropsBase } from "../State";
import ComponentSwitcher from "../components/ComponentSwitcher";
import EnumeratedTable from "../components/EnumeratedTable";

// tslint:disable-next-line: max-line-length
function handleDatesChange(e: React.ChangeEvent<HTMLInputElement>, index: number, answerIndex: number, dispatch: React.Dispatch<Action>, s: string[]): void {
    const newOwnershipState = s.map((v, i) => {
        if (index === i) {
            return e.target.value;
        } else {
            return v;
        }
    });
    dispatch({ type: "handle answer update", value: newOwnershipState, index: answerIndex });
}

// tslint:disable-next-line: max-line-length
function handleDateRangeChange(e: React.ChangeEvent<HTMLInputElement>, index: number, answerIndex: number, dispatch: React.Dispatch<Action>, s: string[]): void {
    const newOwnershipState = s.map((v, i) => {
        if (index === i) {
            return e.target.value;
        } else {
            return v;
        }
    });
    dispatch({ type: "handle answer update", value: newOwnershipState, index: answerIndex });
}

function isAnswerValid(s: string): boolean {
    if (!s || s.length < 10) //don't show until they finish typing date
        return true;

    return dateValidator(s);
}

// tslint:disable-next-line: interface-name
interface Props {
    propsBase: QAPropsBase;
    index: number;
}

const DatesAnswer: React.FunctionComponent<Props> = (props: Props) => {
    const globalState = useContext(store);
    const { dispatch } = globalState;
    const dates = props.propsBase.answerValue as string[];
    const dateGenerator = () => undefined;

    return (
        <div>
            <ComponentSwitcher index={props.index}
                action={{ type: "handle answer update" }}
                answerContent={" : ;Dates of Accident:1;Exposure Period:0"}
                questionContent={"PERFORM SEARCH BY EXPOSURE PERIOD OR DATE(S) OF ACCIDENT?"}
                // tslint:disable-next-line: max-line-length
                arrayProjector={[
                    (o) => Array.from({ length: 2 }, () => ""),
                    (o) => o,
                ]}
                source={dates}
                defaultValue={"1"}
                content={[
                    <EnumeratedTable index={props.index}
                        action={{ type: "handle answer update" }}
                        generator={dateGenerator}
                        inverted={globalState.state.appState.isDarkTheme}
                        questionContent={"ENTER THE EXPOSURE PERIOD BELOW"} fixed={true}
                        source={dates}>
                        {
                            dates.map((o, i, a) =>
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        <Form.Input size={"small"} type={"date"} value={o}
                                            style={{ minWidth: "250px" }} fluid
                                            error={!isAnswerValid(o) && { content: "Please enter valid date in MM/dd/yyyy format." }}
                                            // tslint:disable-next-line: max-line-length
                                            onChange={(e) => handleDateRangeChange(e, i, props.index, dispatch, a)}
                                            label={
                                                (i === 0 && <Label content={"From"} />) ||
                                                (i === 1 && <Label content={"To"} />)
                                            }
                                            // tslint:disable-next-line: max-line-length
                                            labelPosition={"left corner"}
                                        />
                                    </Table.Cell>
                                </Table.Row>)
                        }
                    </EnumeratedTable>,
                    <EnumeratedTable index={props.index}
                        action={{ type: "handle answer update" }}
                        generator={dateGenerator}
                        inverted={globalState.state.appState.isDarkTheme}
                        questionContent={"HOW MANY DATES OF ACCIDENT?"}
                        source={dates}>
                        {
                            dates.map((o, i, a) =>
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        <Form.Input size={"small"} type={"date"} value={o} fluid
                                            error={!isAnswerValid(o) && { content: "Please enter valid date in MM/dd/yyyy format." }}
                                            // tslint:disable-next-line: max-line-length
                                            onChange={(e) => handleDatesChange(e, i, props.index, dispatch, a)}
                                        />
                                    </Table.Cell>
                                </Table.Row>)
                        }
                    </EnumeratedTable>,
                ]}
            />
      </div>
    );
  };

export default DatesAnswer;
